'use client';

import { ReactNode } from 'react';
import Image from 'next/image';

import { TFlagIconsIds } from '@northladder/utilities';

import { FlagArabic } from './FlagArabic';
import { FlagEnglish } from './FlagEnglish';
import { FlagEU } from './FlagEU';
import { FlagGlobal } from './FlagGlobal';
import { FlagHebrew } from './FlagHebrew';
import { FlagIraq } from './FlagIraq';
import { FlagIsrael } from './FlagIsrael';
import { FlagSaudi } from './FlagSaudi';
import { FlagUAE } from './FlagUAE';

import { TSvgComponentProps } from './types';

type FlagIconComponent = (props: TSvgComponentProps) => ReactNode;

/**
 * This consists of all the supported country flag SVG icons to be used in the
 * app.
 */
export const flagIcons: Record<TFlagIconsIds, FlagIconComponent> = {
  arabic: FlagArabic,
  english: FlagEnglish,
  eu: FlagEU,
  german: FlagGlobal,
  global: FlagGlobal,
  hebrew: FlagHebrew,
  iq: FlagIraq,
  iraq: FlagIraq,
  israel: FlagIsrael,
  ksa: FlagSaudi,
  poland: FlagGlobal,
  spain: FlagGlobal,
  uae: FlagUAE,
};

interface IFlagIconProps extends TSvgComponentProps {
  flagUrl?: string;
}

/**
 * -----------------------------------------------------------------------------
 * This component expects a the flag `id` and returns the appropriate flag
 * component. It exposes the rest of the flag props for overriding.
 */
export function FlagIcon({ flagUrl, ...rest }: IFlagIconProps) {
  // Default to global flag if no specific flag is provided
  const Flag = flagIcons.global;

  if (flagUrl) {
    return (
      <Image
        alt=""
        className="profile-image"
        height={40}
        src={flagUrl}
        title="Region flag"
        width={40}
      />
    );
  }

  return <Flag {...rest} />;
}
